/* Gen4Sale filters (full site build 1 Oct 2026, restyled 2 Oct 2026).
   1. An option that stands for several filter values (a kVA range, or a
      Refine by pill that merges two tags with the same name) carries the
      extra values as hidden inputs (snippets/g4s-facet-values.liquid).
      Ticking or unticking the option switches them on or off before the
      theme reads the filter form, so the results cover all of them.
   2. The ticked count after each filter title updates straight away. The
      theme refreshes the sidebar from the server after each change, but in
      the phone drawer it only refreshes the list you're in, so the count on
      that group's title would otherwise lag until the next change. */
(function () {
  if (window.g4sFacetsReady) return;
  window.g4sFacetsReady = true;

  function syncExtras(box) {
    if (!box.matches('input[data-g4s-range]')) return;
    var item = box.closest('li');
    if (!item) return;
    var extras = item.querySelectorAll('input[data-g4s-extra]');
    for (var i = 0; i < extras.length; i++) {
      extras[i].disabled = !box.checked;
    }
  }

  function syncCount(box) {
    var group = box.closest('details.js-filter');
    if (!group) return;
    var summary = group.querySelector('summary');
    var badge = summary && summary.querySelector('.facets__selected');
    if (!badge) return;
    var ticked = group.querySelectorAll('input[type="checkbox"]:checked').length;
    badge.textContent = ticked;
    badge.classList.toggle('hidden', ticked === 0);
  }

  function sync(event) {
    var box = event.target;
    if (!box || !box.matches || !box.matches('input[type="checkbox"]')) return;
    syncExtras(box);
    syncCount(box);
  }

  document.addEventListener('input', sync, true);
  document.addEventListener('change', sync, true);
})();
